import { useNavigate } from 'react-router-dom';
import '../styles/validacaoConvidados.css'

export default function ErroValidar() {
  const navigate = useNavigate();

    const irParaValidacao = () => {
        navigate('/');
    };

    setTimeout(() => {
        navigate('/');
    }, 5000);

    return <div className="valida_documento">
        
        <img src='/images/erro_validar.jpg' alt='validação do documento' className="img_validacao" onClick={irParaValidacao} />    
    
    </div>
}